const watchlists = {
  ips: {
    title: "IP Watchlist",
    fieldType: "ip"
  },
  users: {
    title: "User Watchlist",
    fieldType: "user"
  },
  hashes: {
    title: "File Hash Watchlist",
    fieldType: "hash"
  },
  ports: {
    title: "Port Watchlist",
    fieldType: "port"
  },
  domains: {
    title: "Domain Watchlist",
    fieldType: "domain"
  },
  geolocations: {
    title: "GeoLocation Watchlist",
    fieldType: "geolocation"
  },
  files: {
    title: "File Watchlist",
    fieldType: "file"
  }
};
export default watchlists;
